import { apiGet } from '../../interceptors';

export const AnalyticsService = {
  async fetchAnalytics() {
    const response = await apiGet('/analitics');
    return response.data;
  }
};
